<script setup lang="ts">
    import { computed, watch } from 'vue';
    import { Input } from '@/components/ui/input';
    import { InputRow, Combobox, Select } from '@/components/ui/form';
    import { optionsYesNo } from '@/utils/form';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { useUserData } from '@/composables/useUserData';
    import type { SharedData, User, Employee } from '@/types';
    import { Alert } from '@/components/ui/alert';

    const { t } = useI18n();

    const props = defineProps<{
        form: any;
        employee?: Employee;
    }>();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { users, isPlaceholderDataUsers } = useUserData(selectedCompanyId.value);

    const userOptions = computed(() => {
        return users.value.map((user: User) => ({
            ...user,
            label: `${user.name} (${user.email})`,
            addon: user.employee_id ? t('employee.user.assigned_employee') : null,
            disabled: !!user.employee_id,
        }));
    });
</script>

<template>
    <div class="grid gap-3">
        <InputRow
            v-if="!employee?.user_id"
            :form="form"
            name="create_user"
            label="employee.user.create_user"
        >
            <Select
                v-model="form.user.create_user"
                :options="optionsYesNo"
                :translate="true"
            />
        </InputRow>
        <InputRow
            v-if="form.user.create_user === 0"
            :form="form"
            name="user_id"
            label="employee.user.id"
            error-key="user.id"
        >
            <Combobox
                id="user_id"
                v-model="form.user.id"
                :options="userOptions"
                value-by="id"
                :placeholder="t('employee.user.id')"
                :loading="isPlaceholderDataUsers"
                :disabled="!!employee?.user_id"
            />
        </InputRow>
        <Alert
            v-if="form.user.create_user === 1"
            variant="info"
        >
            {{ t('employee.user.create_info') }}
        </Alert>
    </div>
</template>
